import React, { useMemo, useState } from "react";
import { Button, Box } from "@mui/material";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import { TabPanel } from "@mui/lab";
import TabContext from "@mui/lab/TabContext";
import { styled } from "@mui/material/styles";
import CategoryAlertPending from "./table/categoryAlertPending";
import CategotyAlertResponded from "./table/categotyAlertResponded";
import CategoryAcceptPopup from "./categoryPopups/categoryAcceptPopup";
import CategoryRejectPopup from "./categoryPopups/categoryRejectPopup";
import { getConfig } from "../../../../../../network/auth";
import { baseUrl } from "../../../../../../network/constants/constants";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

const CategoryAlert = ({
  categoryPending,
  categoryResponded,
  fetchAlerts,
  setLoading,
}) => {
  const [tabValue, setTabValue] = useState("1");
  const [openAccept, setOpenAccept] = useState(false);
  const [openReject, setOpenReject] = useState(false);
  const [selectAlertId, setSelectAlertId] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const handleOpenAccept = (id) => {
    setSelectAlertId(id);
    setOpenAccept(true);
  };

  const handleCloseAccept = () => {
    setOpenAccept(false);
  };

  const handleOpenReject = (id) => {
    setSelectAlertId(id);
    setOpenReject(true);
  };

  const handleCloseReject = () => {
    setOpenReject(false);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const config = useMemo(() => {
    return getConfig();
  }, []);

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbar({ ...snackbar, open: false });
  };

  const handleAdminResponse = (id, action) => {
    setLoading(true);

    const payload = {
      status: action === "accept" ? "Accepted" : "Rejected",
    };

    axios
      .put(`${baseUrl}superadmin/alerts-update/${id}/`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: config.headers.Authorization,
        },
      })
      .then((response) => {
        fetchAlerts();
        setSnackbar({
          open: true,
          message: response.data.message,
          severity: "success",
        });
      })
      .catch((error) => {
        console.error("Error updating request status:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const StyledTab = styled(Tab)({
    "&.Mui-selected": {
      color: "#ff4d4d",
    },
  });

  const columns = [
    { field: "displayIndex", headerName: "No", width: 90 },
    { field: "id", headerName: "Alert ID", width: 90 },
    { field: "business_name", headerName: "business Name", width: 200 },
    { field: "category_name", headerName: "category Name", width: 200 },
    {
      field: "icon",
      headerName: "category Image",
      width: 200,
      renderCell: (params) => (
        <img
          src={`${baseUrl}${params.row.icon}`}
          alt={params.row.category_name}
          style={{ width: "20%", height: "auto" }}
        />
      ),
    },
    { field: "status", headerName: "Status", width: 200 },
    {
      field: "acceptReject",
      headerName: "Actions",
      width: 400,
      sortable: false,
      renderCell: (params) => (
        <>
          <Button
            variant="outlined"
            color="success"
            style={{ marginRight: "5px" }}
            onClick={() => handleOpenAccept(params.row.id)}
          >
            Accept
          </Button>
          <Button
            variant="outlined"
            color="error"
            style={{ marginRight: "5px" }}
            onClick={() => {
              handleOpenReject(params.row.id);
            }}
          >
            Reject
          </Button>
        </>
      ),
    },
  ];

  const respondedColumns = columns.filter(
    (column) => column.field !== "acceptReject"
  );

  return (
    <>
      <TabContext value={tabValue}>
        <Box
          sx={{
            flexGrow: 1,
            maxWidth: { xs: 650, sm: 1500 },
            bgcolor: "background.paper",
          }}
        >
          <TabList
            aria-label="lab API tabs example"
            onChange={handleTabChange}
            TabIndicatorProps={{
              style: {
                backgroundColor: "#ff4d4d",
              },
            }}
          >
            <StyledTab
              label="New request"
              sx={{ textTransform: "none" }}
              value="1"
            />
            <StyledTab
              label="Responded request"
              sx={{ textTransform: "none" }}
              value="2"
            />
          </TabList>
          <TabPanel value="1">
            <CategoryAlertPending
              categoryPending={categoryPending}
              requestColumn={columns}
            />
          </TabPanel>
          <TabPanel value="2">
            <CategotyAlertResponded
              categoryResponded={categoryResponded}
              respondedColumns={respondedColumns}
            />
          </TabPanel>
        </Box>
      </TabContext>
      <CategoryAcceptPopup
        open={openAccept}
        onClose={handleCloseAccept}
        handleAdminResponse={handleAdminResponse}
        selectAlertId={selectAlertId}
      />
      <CategoryRejectPopup
        open={openReject}
        onClose={handleCloseReject}
        handleAdminResponse={handleAdminResponse}
        selectAlertId={selectAlertId}
      />
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default CategoryAlert;
